import axios from "axios";
import Axios from "@/api/BaseAxios.js";
import { getToken } from "../../common/commonFunctions";

const state = {
  checkStatus: "PROFILE",
  isPrivate: false,
  flagVerified: false,
  readCount: 0,
  userProfileTitle: "",
  userProfileId: "",
  is_logged_in: false,
  followers: [],
  followersMeta: {
    totalPages: 1,
    pagesLoaded: 0,
  },
};

const getters = {
  notificationCount: (state) => {
    return state.readCount;
  },

  followersHasMorePage(state) {
    let meta = state.followersMeta;
    return meta.totalPages > meta.pagesLoaded;
  },
};

const actions = {
  getNotifications({ commit }) {
    const user_id = localStorage.getItem("user_id");
    if (!user_id) {
      return false;
    }
    const successHandler = (res) => {
      // const unreadNotifications = res.data.result.filter(
      //   (item) => item.read === false
      // );
      // console.log(unreadNotifications);
      commit("updateNotifications", res.data.total_unread_count);
    };
    const errorHandler = (err) => {
      console.error("notification", err);
    };
    Axios.request_GET(
      `api/my-notifications/${user_id}`,
      {},
      {},
      successHandler,
      errorHandler,
      false,
      false
    );
  },

  async loginWithSSO(
    { commit, dispatch },
    { uid, idToken, name, email, profilePicture, provider }
  ) {
    let data;

    try {
      const res = await this.$axios.post(`/api/firebase-auth/${provider}/`, {
        uid: uid,
        id_token: idToken,
        name,
        email,
        profile_picture: profilePicture,
      });
      data = res.data;
      console.log("data", data.first_time_user);
      if (data.first_time_user) {
        console.log("new user event fire");
        // this.$logEvent("new_user_login_successfully");
        window.dataLayer.push({ event: "new_user_login_successfully" });

        if (this.$vuetify.breakpoint.xsOnly) {
          // this.$logEvent("mweb_new_user_login_successfully");
          window.dataLayer.push({ event: "mweb_new_user_login_successfully" });

          console.log("mnew user event fire");
        }
      }
      // if (data.first_time_user) {
      //   this.$logEvent("new_user_successfully_login");
      //   console.log("new user event fire");
      //   if (this.$vuetify.breakpoint.xsOnly) {
      //     this.$logEvent("mweb_new_user_successfully_login");
      //     console.log("mnew user event fire");
      //   }
      // }
    } catch (error) {
      if (error.response) {
        dispatch(
          "snackBar/showSnack",
          {
            text: error.response.data.non_field_errors[0],
            color: "error",
          },
          { root: true }
        );
        return;
      }
    }

    localStorage.setItem("user_id", data.user_id);
    localStorage.setItem("token", data.token);
    localStorage.setItem("profile_id", data.profile_id);
    localStorage.setItem("verified", data.user_id);
    localStorage.setItem("access", data.token.access);
    localStorage.setItem("refresh", data.token.refresh);
    localStorage.setItem("user_type", data.user_type);

    if (data.is_profile_setup_complete) {
      commit("setIsPrivate", true);
      commit("setCheckStatus", "HOME");
    } else {
      commit("setCheckStatus", "PROFILE");
    }
    // if (data.first_time_user) {
    //   this.$logEvent("new_user_successfully_login");

    //   if (this.$vuetify.breakpoint.xsOnly) {
    //     this.$logEvent("mweb_new_user_successfully_login");
    //   }
    // }
  },

  async fetchFollowers({ commit, getters, state }) {
    if (!getters.followersHasMorePage) return;
    const page = state.followersMeta.pagesLoaded + 1;
    const search_query = state.followersMeta.search_query;
    let headers = {};
    headers["Authorization"] = `Bearer ${getToken()}`;
    let config = {};
    config["headers"] = headers;
    const data = (
      await axios.get(
        `/api/followers/?page=${page}&search_query=${search_query}`,
        config
      )
    ).data;
    const list = data.results;
    commit("appendFollowers", list);
    commit("setFollowersMeta", {
      totalPages: Math.ceil(data.count / process.env.VUE_APP_PAGE_SIZE),
      pagesLoaded: page,
      search_query: search_query,
    });
  },
};

const mutations = {
  updateNotifications: (state, payload) => {
    state.readCount = payload;
  },

  setIsPrivate(state, value) {
    state.isPrivate = value;
  },

  setCheckStatus(state, value) {
    state.checkStatus = value;
  },

  appendFollowers(state, value) {
    state.followers = state.followers.concat(value);
  },

  setFollowersMeta(state, value) {
    state.followersMeta = value;
  },

  setFollowersMetaSearchQuery(state, value) {
    state.followersMeta.search_query = value;
    state.followersMeta.pagesLoaded = 0;
    state.followersMeta.totalPages = 1;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
